export enum ProductSpecification {
    PREVIEW = 'Preview',
    TEST = 'Test',
}
